module.exports = __webpack_public_path__ + "static/img/instant6.d0b58a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/instant6.png
// module id = 9MPC
// module chunks = 1